  <app-navbar-top *ngIf="showNavTopBar" ></app-navbar-top>
  
  <div *ngIf="isLoading | async"  class="loader-overlay">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <app-toast></app-toast>
  <router-outlet></router-outlet>
  <app-footer class="mt-auto" *ngIf="showFooterBar"></app-footer>
 
<ngx-spinner
  bdColor="rgba(0,0,0,0.3)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner>


<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->


<!-- <ngx-spinner type="ball-clip-rotate"></ngx-spinner> -->